import { render, staticRenderFns } from "./dapp-box2.vue?vue&type=template&id=224b2a50&scoped=true&"
import script from "./dapp-box2.vue?vue&type=script&lang=js&"
export * from "./dapp-box2.vue?vue&type=script&lang=js&"
import style0 from "./dapp-box2.vue?vue&type=style&index=0&id=224b2a50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b2a50",
  null
  
)

export default component.exports